<template>
    <div>
        <!-- 头部区域 哇哇哇哇哇-->
        <div id="top-par" class="layui-header my-layui-header">
            <!-- 头部区域颜色设置 -->
            <div style="width: 100%;height: 60px;position: fixed;left: 0px;top: 0px;z-index: 1002;background:#181818;">
                <!-- 头部区域 -->
                <el-row :gutter="10" style="height: 60px;">
                    <el-col :span="12">
                        <ul class="layui-nav layui-layout-left" style="margin-left: -15px;">
				               <li class="layui-nav-item layadmin-flexible" id="top-bar-flexible"
				               @mouseover="leftItemMouseOver('top-bar-flexible')"
				               @mouseout="leftItemMouseOut('top-bar-flexible')">
				                   <a href="javascript:;" style="color: #6C6D7B!important;"  title="侧边伸缩" @click="sideShrink()">
				                   <i style="font-size: 20px;" class="layui-icon layui-icon-shrink-right " :class="{'layui-icon-spread-left' : $store.state.style.sideShrink}"></i>
				                   </a>
				               </li>
				           </ul>
                        <div :style="{ 'left': $store.state.style.sideShrink ? '100px' : '224px' }"
                            style="color:#fff;font-weight:bold;font-size:25px;position: absolute;top: 10px;">物联网管理平台</div>
                    </el-col>
                    <el-col :span="12">
                        <ul class="layui-nav layui-layout-right">
                            <li class="layui-nav-item layui-hide-xs" id="top-bar-user"
                                @mouseover="rightItemMouseOver('top-bar-user')"
                                @mouseout="rightItemMouseOut('top-bar-user')">
                                <i style="font-size: 20px;cursor: pointer;" @click="downPdf()" title="API文档下载"
                                    class="layui-icon layui-icon-shrink-right el-icon-download">API文档下载</i>

                                <a @click="upbit = !upbit" href="javascript:;"
                                    style="color:#fff!important;display: inline-block;">
                                    <img src="./../../assets/kairan.png" class="layui-nav-img"
                                        style="cursor: pointer;width: 40px;height: 40px;border-radius: 10px;">
                                    {{ nickName }}
                                    <span style="border-top-color:#fff;" class="layui-nav-more "></span>
                                </a>

                                <dl class="layui-nav-child layui-anim layui-anim-upbit my-panel "
                                    :class="{ 'layui-show': upbit }">
                                    <dd @click="handleCommand('logout')" style="width: 10px;">
                                        <a href="javascript:;"><i class="fa fa-sign-out"></i> 安 全 退 出 ( {{ accountName }}
                                            )</a>
                                    </dd>
                                </dl>

                            </li>
                            <li class="layui-nav-item layui-show-xs-inline-block layui-hide-sm" id="top-bar-more"
                                @click="sm_upbit = !sm_upbit">
                                <a href="javascript:;">
                                    <i class="layui-icon layui-icon-more-vertical"></i>
                                </a>
                                <dl class="layui-nav-child layui-anim layui-anim-upbit my-panel "
                                    :class="{ 'layui-show': sm_upbit }">
                                    <hr>
                                    <dd @click="handleCommand('logout')">
                                        <a href="javascript:;"><i class="fa fa-sign-out"></i> 退出</a>
                                    </dd>
                                </dl>
                            </li>
                        </ul>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="layadmin-tabsbody-item layui-show dsdsa"
            :style="{ 'margin-left': $store.state.style.sideShrink ? '50px' : '200px' }">
            <el-tabs :value="activeSubItem" @tab-remove="closeTab" class='content-body' @tab-click="tabClick($event)"
                type="border-card" :before-leave="handleBeforeLeave">
                <el-tab-pane v-for="item in tabs" :label="item.label" :key="item.index" :name="item.index"
                    :closable="item.closable">
                    <template v-if="item.label == '卡片详情' || item.label == '卡片信息'">
                        <async-component v-if="refreshFlag" :componentPath='item.component'></async-component>
                    </template>
                    <template v-else>
                        <template v-if="item.label == '数据汇总' || item.label == '数据统计'">
                            <async-component :componentPath='item.component'></async-component>
                        </template>
                        <template v-else-if="item.label == '系统监控'">
                            <async-component :componentPath='item.component'></async-component>
                        </template>
                        <template v-else>
                            <async-component :componentPath='item.component' class="app-body-content"></async-component>
                        </template>
                    </template>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>


<script>
import { getUserInfo, modifyPwd, downPdfFile } from '@/api/user.js'
import { agentHomeNotify, agentHomeNotifyReaded } from '@/api/system.js'
import common from '@/utils/common.js'
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import AsyncComponent from "@/views/home/AsyncComponent";
export default {
    components: {
        // AdminIndex,
        AsyncComponent
    },
    data() {
        return {
            nickName: '',
            accountName: '',

            refreshFlag: true,
            //顶部左侧菜单
            leftBarLeft: 0,
            leftBarWidth: 0,
            leftBarOpacity: 0,
            //顶部右侧菜单
            rightBarLeft: 0,
            rightBarWidth: 0,
            rightBarOpacity: 0,
            //全屏状态
            fullscreen: false,
            //显示修改密码菜单栏
            upbit: false,

            sm_upbit: false,

            oneNotify: '',
            notifyId: '',

        }
    },
    methods: {
        downPdf() {
            this.upbit = false;
            var link = document.createElement('a');
            link.setAttribute('download', '');
            link.href = '../../../doc/通用API文档.pdf';
            link.click();
        },
        ...mapGetters("menu", {
            getNickName: "getNickName",
        }),
        ...mapMutations('menu', {
            addTab: 'addTab',
            switchTab: 'switchTab'
        }),
        handleCommand(command) {
            switch (command) {
                case 'logout':
                    this.logoutHandler();
                    break;
                case 'toPersonalCenter':
                    this.toPersonalCenter();
                    break;

                default:
                    break;
            }
        },
        ...mapActions("menu", {
            closeTab: "closeTab",
            switchTab: "switchTab"
        }),

        tabClick(e) {
            this.switchTab(e.name)
        },
        handleBeforeLeave(activeName, oldActiveName) {
            if (this.$store.state.menu.fromPage == 'cardMgt' || this.$store.state.menu.fromPage == 'cardList' || this.$store.state.menu.fromPage == 'orderMgt') {
                this.refreshFlag = false
            }
            this.$nextTick(() => {
                this.refreshFlag = true;
            })
        },
        toPersonalCenter() {
            if (!this.$store.state.menu.isPersonalCenterTab) {
                let newTab = {
                    label: '个人中心',
                    index: 'personalCenter',
                    closable: true,
                    component: "views/statistics/personalCenter"
                }
                this.$store.commit('menu/addTab', newTab);
                this.$store.commit('menu/setIsPersonalCenterTab', true);
            }
            this.$store.commit('menu/switchTab', 'personalCenter')
        },


        logoutHandler() {
            if (this.oneNotify) {
                this.oneNotify.close();
            }
            var menuState = this.$store.state.menu;
            for (var key in menuState) {
                switch (typeof (menuState[key])) {
                    case 'string':
                        menuState[key] = ''
                        break;
                    case 'object':
                        menuState[key] = []
                        break;
                    default:
                        break;
                }
            }

            let loginAccounts = localStorage.getItem('loginAccounts');//记住账号
            localStorage.clear();
            if (loginAccounts != null && loginAccounts != undefined && loginAccounts.length > 0) {
                this.setAutoCompleteData("loginAccounts", loginAccounts);
            }

            this.$store.commit('menu/setIsPersonalCenterTab', false);
            this.$router.push('/');
        },
        getAgentNotify(data) {
            // if(sessionStorage.getItem("isCollect")==1){
            //     return;
            // }
            agentHomeNotify(data).then(res => {
                if (res.data.code == 200) {
                    this.notifyId = res.data.data.id;
                    const h = this.$createElement;
                    this.oneNotify = this.$notify({
                        title: res.data.data.title,
                        dangerouslyUseHTMLString: true,
                        message: h('div', null, [
                            h('div', {
                                domProps: {
                                    // 'innerHTML': `${res.data.data.content.replace(/\n/g, '<br>')}` 
                                    'innerHTML': res.data.data.content
                                },
                                style: {
                                    'padding': '0 20px'
                                }
                            }),
                            h('div', null, [
                                h('p', { style: 'font-size: 12px;padding-left:20px' }, `${res.data.data.currentTime}`),
                                h('el-checkbox', {
                                    style: 'float: right;padding-bottom:20px;padding-right:20px;',
                                    on: {
                                        change: this.notifyReadedHandler
                                    }
                                }, '已读')
                            ])
                        ]),
                        customClass: "el-alert-notify",
                        position: 'bottom-right',
                        style: {
                            'font-size': '14px'
                        },
                        duration: 0
                    })
                }
            })
        },
        //     top: 0;
        // left: 0;
        // bottom: 0;
        // right: 0;
        // margin: auto;
        // height: 136px;
        notifyReadedHandler() {
            var data = {
                id: this.notifyId,
                accountName: this.accountName
            }
            agentHomeNotifyReaded(data)
        },
        //收起左侧菜单栏
        sideShrink() {
            let w = window.innerWidth
                || document.documentElement.clientWidth
                || document.body.clientWidth;

            let h = window.innerHeight
                || document.documentElement.clientHeight
                || document.body.clientHeight;


            if (this.$store.state.style.sideShrink) {
                this.$store.commit('style/setSideShrink', false);
            } else {
                this.$store.commit('style/setSideShrink', true);
                //收起子菜单
                this.$store.commit('menu/setActiveItem', '0');
            }

        },

        //顶部左侧菜单鼠标进入
        leftItemMouseOver(id) {
            this.leftBarLeft = document.getElementById(id).offsetLeft;
            this.leftBarWidth = document.getElementById(id).offsetWidth;
            this.leftBarOpacity = 1;
        },
        //顶部左侧菜单鼠标移出
        leftItemMouseOut(id) {
            this.leftBarWidth = document.getElementById(id).offsetWidth;
            this.leftBarOpacity = 0;
            this.leftBarLeft = document.getElementById(id).offsetLeft;
        },

        //顶部右侧菜单鼠标进入
        rightItemMouseOver(id) {
            this.rightBarLeft = document.getElementById(id).offsetLeft;
            this.rightBarWidth = document.getElementById(id).offsetWidth;
            this.rightBarOpacity = 1;
        },
        //顶部又侧菜单鼠标移出
        rightItemMouseOut(id) {
            this.rightBarWidth = document.getElementById(id).offsetWidth;
            this.rightBarOpacity = 0;
            this.rightBarLeft = document.getElementById(id).offsetLeft;
        },

        //主题面板显隐切换
        popTheme() {
            let ele = document.getElementById('LAY_adminPopupTheme');
            var w = ele.style.width;
            if (w == null || w == '' || w == '0px') {
                ele.style.width = "320px";
            } else {
                ele.style.width = "0px";
            }
        },


        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            // 判断是否已经是全屏
            // 如果是全屏，退出
            if (this.fullscreen) {
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {    // 否则，进入全屏
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            // 改变当前全屏状态
            this.fullscreen = !this.fullscreen;
        }
    },
    created() {
        var data = {
            id: localStorage.getItem('id')
        }
        getUserInfo(data).then(res => {
            if (res.data.code == 200) {
                var result = res.data.data;
                this.nickName = result.nickName;
                this.accountName = result.accountName;
                var loginSysRoleVoList = result.loginSysRoleVoList;
                loginSysRoleVoList.forEach(item => {
                    if (item.id == 100) {
                        var data = {
                            accountName: result.accountName
                        }
                        this.getAgentNotify(data);
                    }
                });

                var firstList = result.loginSysMenuVoList[0].nextLoginMenuVoList[0];
                var tab = this.$store.state.menu.tabs.find(f => f.index == firstList.id)
                if (!tab) {
                    var newTab = {
                        label: firstList.name,
                        index: firstList.id,
                        component: 'views/' + firstList.path
                    }
                    this.addTab(newTab)
                }
                this.switchTab(firstList.id)
            } else {
                this.$message.error(res.data.message)
            }
        })
    },

    mounted() {

    },

    computed: {
        // ...mapGetters("menu", {
        //     hasAuthority: "hasAuthority" 
        // }),
        ...mapState("menu", {
            tabs: "tabs",
            activeSubItem: "activeSubItem"
        })
    },


};
</script>
<style lang="less">
.app-breadcrumb.el-breadcrumb {
    display: block;
    font-size: 14px;
    line-height: 50px;
    padding-left: 10px;
    box-shadow: 0px 0px 5px #e5e5e5;

    .no-redirect {
        color: #97a8be;
        cursor: text;
    }
}

.el-tabs__content {
    transition: all .3s;


    // background: #fff;    
    border-radius: 3px;
    padding: 10px;
    // box-shadow: 0 0 8px rgba(0,0,0,.15);


    -ms-overflow-style: none; //IE 10+
    overflow: -moz-scrollbars-none; //Firefox
}

.el-alert-notify {
    bottom: auto !important;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    padding: 0;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    width: 530px;

    .el-notification__group {
        margin: 0;
        width: 100%;

        .el-notification__title {
            line-height: 50px;
            background: #eee;
        }

        .el-notification__content {
            padding: 10px;
            color: #999;

            /deep/ p {
                padding-top: 10px;
            }

            /deep/label {
                position: absolute;
                bottom: 10px;
                right: 16px;
            }
        }
    }
}
</style>
<style lang="less" scoped>
.app-body-content {
    transition: all .3s;


    background: #fff;
    border-radius: 3px;
    padding: 10px;
    //box-shadow: 0 0 8px rgba(0,0,0,.15);


    -ms-overflow-style: none; //IE 10+
    overflow: -moz-scrollbars-none; //Firefox
}

#app-body-content::-webkit-scrollbar {
    display: none; //Safari and Chrome
}

.layadmin-tabspage-none {
    * {
        transition: all .3s;
    }
}

.layadmin-view-xs.layadmin-side-shrink {
    * {
        transition: all .3s;
    }

    .layui-layout-left {
        left: 45px;
    }
}

.layadmin-view-sm {
    .layui-layout-right {
        right: -60px;
    }
}


.layadmin-view-sm.layadmin-side-shrink {
    * {
        transition: all .3s;
    }

    .layui-layout-left {
        left: 0px;
    }

    .layui-layout-right {
        right: 0px;
    }
}

.my-layui-header {
    z-index: 1002;
    height: 60px;
    background: #fff;

    .my-panel {
        position: absolute;
        z-index: 1002;
    }
}

::v-deep .el-tabs--border-card {
    border: 0;
    background: #F3F5F9;
}</style>
